import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=a96965d4&scoped=true&"
import script from "./NotificationEdit.vue?vue&type=script&lang=js&"
export * from "./NotificationEdit.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEdit.vue?vue&type=style&index=0&id=a96965d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96965d4",
  null
  
)

export default component.exports